import { Route } from "react-router-dom";
import ProtectedRoute from "./Components/ProtectedRoute";
import RegisterRoute from "./Components/RegisterRoute";
import {
  Login,
  Signup,
  FAQs,
  ResetPassword,
  Dashboard,
  UserChildren,
  Services,
  RegistrationForm,
  Parents,
  SingleChild,
  Bookings,
  Profile,
} from "./Pages";

export function getRoutes() {
  const routes = [
    {
      path: "/",
      component: <Dashboard />,
      isPublic: false,
    },
    {
      path: "/login",
      component: <Login />,
      isPublic: true,
    },
    {
      path: "/signup",
      component: <Signup />,
      isPublic: true,
    },
    {
      path: "/faqs",
      component: <FAQs />,
      isPublic: false,
    },
    {
      path: "/reset-password",
      component: <ResetPassword />,
      isPublic: true,
    },
    {
      path: "/children",
      component: <UserChildren />,
      isPublic: false,
    },
    {
      path: "/children/:childId",
      component: <SingleChild />,
      isPublic: false,
    },
    {
      path: "/activities",
      component: <Services />,
      isPublic: false,
    },
    {
      path: "/registration-form",
      component: <RegistrationForm />,
      isPublic: false,
    },
    {
      path: "/parents",
      component: <Parents />,
      isPublic: false,
    },
    {
      path: "/bookings",
      component: <Bookings />,
      isPublic: false,
    },
    {
      path: "/profile",
      component: <Profile />,
      isPublic: false,
    },
  ];
  var routeElements = routes.map((route, index) => {
    return route.isPublic ? (
      <Route key={index} exact path={route.path} element={route.component} />
    ) : (
      <Route
        key={index}
        exact
        path={route.path}
        element={
          <ProtectedRoute>
            <RegisterRoute>{route.component}</RegisterRoute>
          </ProtectedRoute>
        }
      />
    );
  });
  return routeElements;
}
